import { Metamodel } from '../../base/model';
import { AzureBlobFSLocation } from './azure-blobfs.location';
import { SapDatasphereForAzureDataLakeStorageGen2LinkedService } from '../../linkedservice/sap-datasphere-for-azure-data-lake-storage-gen2.linkedservice';

@Metamodel.model({
    name: 'SapDatasphereForAzureDataLakeStorageGen2Location',
    tags: {
        linkedServiceModel: Metamodel.modelFor(SapDatasphereForAzureDataLakeStorageGen2LinkedService)
    }
})
export class SapDatasphereForAzureDataLakeStorageGen2Location extends AzureBlobFSLocation {}
